import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Badge from 'antd/lib/badge';
import styles from './CustomWidgetIcon.module.css';
import DynamicIcon from '@components/dynamicIcon/dynamicIcon';
import GateIcon from '@components/gateIcon/gateIcon';
import { WIDGET_DEFAULT_ICON_NAME } from '@common/constants';
import SvgFromString from '@components/SvgFromString/SvgFromString';
import { isSvgString, addWhiteFillToSvg } from '@components/gates/common';

export type CustomWidgetIconInfo = {
	/** Optional background color for the icon wrapper. */
	color?: string;
	/** Optional icon name or svg string. */
	icon?: string;
	/** Whether the widget is disabled (renders gray background). */
	disabled?: boolean;
	/** Whether this represents a widget bundle (forces svg rendering). */
	isBundle?: boolean;
	/** Whether the widget's parent service is in dev mode. */
	devMode?: boolean;
};

/**
 * Renders a consistent icon for custom widgets, supporting both font icons and svg strings.
 * @returns the rendered icon element
 */
const CustomWidgetIcon = (props: CustomWidgetIconInfo): React.JSX.Element => {
	const isCustomSvg = isSvgString(props.icon);

	const iconElement = (
		<GateIcon
			style={{ backgroundColor: props.disabled ? 'gray' : props.color }}
			className={styles.WidgetIcon}
			icon={
				props.isBundle || isCustomSvg ? (
					<SvgFromString
						svgStr={addWhiteFillToSvg(props.icon || '')}
						width={32}
						height={32}
					/>
				) : (
					<DynamicIcon
						iconName={props.icon || WIDGET_DEFAULT_ICON_NAME}
						default={<FontAwesomeIcon icon={['fas', WIDGET_DEFAULT_ICON_NAME]} />}
					/>
				)
			}
		/>
	);

	if (props.devMode) {
		return (
			<Badge
				count="dev"
				size="small"
				offset={[-5, 0]}
				color="red"
			>
				{iconElement}
			</Badge>
		);
	}

	return iconElement;
};

export default CustomWidgetIcon;


